import React from 'react';
import { View, ActivityIndicator, ScrollView, StyleSheet } from 'react-native';
import ItemList from '../components/ItemList';

import { retrieve_table_type } from '../api/table';
import { retrieve_menu } from '../api/menu';
import { type RetrieveMenuType, type RetrieveTableType } from '../types/API';
import { type MenuTypeType, type TableType } from '../types/Schema';
import { type MenuProps } from '../types/ScreenTypes';
import { ScreenSizeContext } from '../context/ScreenSizeContext';
import { Divider } from '@rneui/themed';
import { useLanguage } from '../context/LanguageContext';
import { useTranslation } from 'react-i18next';

const styles = StyleSheet.create({
    container: {
        width: '100%',
        padding: 24,
        backgroundColor: '#fff',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

const Menu: React.FC<MenuProps> = () => {
    const [tableList, setTableList] = React.useState<TableType[]>([]);
    const [menuMap, setMenuMap] = React.useState<MenuTypeType>({});

    const { t } = useTranslation();
    const { currentLanguage } = useLanguage();

    const dimensions = React.useContext(ScreenSizeContext);

    const afterRetrieveTableType = (data: RetrieveTableType): void => {
        const tableList = data.items;
        setTableList(tableList);
    };

    const afterRetrieveMenu = (data: RetrieveMenuType): void => {
        const menuMap = data.item;
        setMenuMap(menuMap);
    };

    React.useEffect(() => {
        void retrieve_table_type(afterRetrieveTableType);
        void retrieve_menu(afterRetrieveMenu);
    }, []);

    return (
        <View style={styles.container}>
            {Object.keys(tableList).length !== 0 &&
            Object.keys(menuMap).length !== 0 ? (
                <ScrollView
                    style={{
                        width: dimensions.window.width > 600 ? '50%' : '100%',
                        alignContent: 'center',
                    }}
                >
                    <ItemList
                        tableList={tableList}
                        key="table"
                        title={t('table')}
                    />
                    <Divider />
                    {Object.entries(menuMap).map(([key, item]) => (
                        <ItemList
                            key={key}
                            title={item.name[currentLanguage]}
                            tableList={item?.menu_list}
                        />
                    ))}
                </ScrollView>
            ) : (
                <ActivityIndicator />
            )}
        </View>
    );
};

export default Menu;
